import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, forkJoin, of, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BreadDik, Person, QResult, QueovalDik, QueovalItem, Select } from "../../../../models";
import { ClientConvention, ConventionData, ConventionModel, ConventionStageData } from "../../../../models/formation/convention.models";
import { Stage } from "../../../../models/formation/formation.model";
import { BreadcrumbService, CoreService, HttpService } from "../../../../services";
import { ToastService } from "../../../../toast";




@Injectable()
export class ConventionService implements OnDestroy {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    private toast: ToastService,
    private breadCrumb: BreadcrumbService,
  ) {
  }

  /** liste des clients rattachés au stage */
 
  public dossiers: Array<Select>
  public EntiteFact: Array<QueovalItem> = [];

  /**
 * récupération des données du client sélectionné
 * @param pClient
 */
  public OnSelectClient(pClient: ClientConvention, pIdStage: string): Observable<[ConventionData, ClientConvention]> {
    if (!pClient.displayed)
      return of([pClient.newConvention, pClient]);
    // compte le nombre de conventions sauvegardées
    pClient.NbConventions = pClient?.Conventions ? pClient.Conventions.filter(c => c.Ident && c.Ident != '0').length : 0;
    //si on a déjà chargé les données de ce clients on ne refait pas les appels serveur
    if (pClient.DataRetrieved) {
      return of([pClient.newConvention, pClient]);
    }

    pClient.DataRetrieved = true;
    const newCvt = this.http.getHttp<QResult<ConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_NEW_CVT/${pIdStage}|${pClient.Ident}`).pipe(
      map((result: QResult<ConventionData>) => {
        //récupération de modèle de convention pour les nouvelles conventions
        const conv: ConventionData = new ConventionData();
        conv.Ident = '0';
        result.Value.displayed = true;
        pClient.newConvention = result.Value ? result.Value : conv;
        return result.Value;
      }));
    pClient.loading = true;
    // récupération des conventions du client sélectionné
    const Cvts = this.http.getHttp<QResult<Array<ConventionData>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_CVT_CLIENT/${pIdStage}|${pClient.Ident}`).pipe(
      map((result: QResult<Array<ConventionData>>) => {
        pClient.loading = false;
        pClient.Conventions = result.Value ? result.Value.map(cvt => {
          //bloque la génération automatique de la ligne de facture si aucune entité de facturation enregistrée sur la convention.
          cvt.showbuttongenerate = (!!cvt.IdEntiteFact && cvt.IdEntiteFact != '0');
          return cvt;
        }) : [];
        return pClient;
      }));

    //const stages = this.http.getHttp<QResult<Array<ConventionStageData>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/ListeStages/${pIdStage}/${pClient.Ident}`);
    //stages.subscribe();
    //forkJoin(Cvts, stages).pipe(
    //  map((result: [ClientConvention, QResult<Array<ConventionStageData>>]) => {
    //    pClient.Conventions.forEach(cvt => {
    //      cvt.Stages = [... new Map(cvt.Stages.concat(result[1].Value).map(stage => [stage.Value, stage])).values()];
    //    });
    //  }));
    return forkJoin([newCvt, Cvts]);
  }

  ngOnDestroy(): void { }
}
